export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";